import { NavigatorScreenParams } from "@react-navigation/core"

import { ExerciseParamList } from "../../screens/ExerciseScreen/ExerciseNavigator"

export type NewClientOnboardingParamList = {
  NewClientSelectProfile: undefined

  NewClientPatientConfirmation: undefined
  NewClientPatientRecommendation: undefined
  NewClientPatientPathologyIntro: undefined
  NewClientOrganSelect: undefined
  NewClientPathology: { organId: string; specialty: string }
  NewClientPatientThankYou: undefined

  NewClientProfessionalSelect: undefined
  NewClientProfessionalThankYou: undefined
}

// eslint-disable-next-line no-shadow
export enum CongratType {
  session,
  misession,
  program,
  phase,
  end,
}

export type OnboardingParamList = {
  /** Sign in screen names of patient */
  Welcome: undefined
  Cgu: undefined
  Register: undefined
  RegisterActivationCode: undefined
  RegisterCgu: undefined
  RegisterResearchData: undefined
  RegisterPecanWorkflowExplanation: undefined
  RegisterVerifyIdentity: undefined
  RegisterVerifyIdentitySuccess: undefined
  RegisterPracticianWorkflow: undefined
  RegisterCodeAlreadyUsed: undefined
  ResearchData: undefined
  ActivationCode: undefined
  Phone: undefined
  SMSValidation: { phoneNumber: string }
  Specialty: undefined
  OperationNavigator: undefined
  OncoPathologyNavigator: undefined
  Profile: undefined
  Alert: undefined
  Language: undefined
  /** Sign in screen names of practitioner */
  Practitioner: undefined
  PractitionerProfile: undefined
  SurgeonPractice: undefined
  PromsNavigator: undefined
  Video: undefined
  ShareContact: undefined
  KineSpecialties: undefined
  Address: undefined
  RdvUrl: undefined
  NewClientNavigator: undefined
}

export type RootParamList = {
  Onboarding: undefined
  LoadingScreen: undefined
  /** main screen names of patient */
  LinkPasswordProvider: undefined
  NeedEmailVerified: undefined
  MfaRegister: undefined
  Login: undefined
  ForgotPassword: undefined
  MfaLogin: { verifId: string }
  Mfa: undefined
  MfaValidation: { phoneNumber: string }
  MigrationFinalized: undefined
  MainNavigator: undefined
  ExerciseNavigator: NavigatorScreenParams<ExerciseParamList>
  Congratulation: { type: CongratType }
  MorningEvaluation: { endProgram?: boolean }
  EndOfFirstSessionEvaluation: { endProgram?: boolean; validationExIsLast?: boolean }
  /** edition screen names of patient */
  SMSValidationEdition: { phoneNumber: string }
  PhoneEdition: undefined
  LanguageEdition: undefined
  MedicalInfos: undefined
  OperationEdition: undefined
  MedicalTeamEdition: undefined
  ProfileEdition: undefined
  NeedNewPassword: undefined
  PasswordModification: undefined
  ValidationMfaPasswordModification: { verifId: string }
  AlertEdition: undefined
  ParametersEdition: undefined
  /** edition screen names of practitioner */
  AddPatient: undefined
  ShareContactEdition: undefined
  PracticianListData: undefined
  KineSpecialtiesEdition: undefined
  AddressEdition: undefined
  DeleteAccount: undefined
  ExportData: undefined
  PractitionerProfileEdition: undefined
  SurgeonPracticeEdition: undefined
  ReviewUrl: undefined
  RdvUrl: undefined
  /** edition screen onco data */
  OncoDataEdition: undefined
  OncoSurgeries: undefined
  Therapies: undefined
  OtherPathologies: undefined
  HeartDisease: undefined
  RespiratoryDisease: undefined
  /** PROMS */
  PromsNavigator: undefined
  Research: undefined
  /** Link requests lists */
  KineList: undefined
  SurgeonList: undefined
  PatientsRequestsScreen: undefined
  KineRequestedScreen: undefined
  CodeInfoScreen: undefined
  KineInfoScreen: undefined
  /** Common screens */
  AboutScreen: undefined
}
